// src/components/financial/FinancialCharts.js
import React from 'react';

function FinancialCharts({ monthlyData, expenses, payments }) {
  const maxAmount = Math.max(
    ...monthlyData.map(m => Math.max(m.collected, m.spent))
  );

  return (
    <div>
      <h3 style={{ marginBottom: '20px' }}>Financial Trends - Last 6 Months</h3>
      
      {/* Bar Chart */}
      <div style={{
        background: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px'
      }}>
        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-end', height: '200px' }}>
          {monthlyData.map((month, index) => (
            <div key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ 
                display: 'flex', 
                gap: '5px', 
                alignItems: 'flex-end',
                height: '160px'
              }}>
                {/* Income Bar */}
                <div style={{
                  width: '20px',
                  height: `${(month.collected / maxAmount) * 150}px`,
                  background: '#28a745',
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 0.3s ease'
                }}></div>
                
                {/* Expense Bar */}
                <div style={{
                  width: '20px',
                  height: `${(month.spent / maxAmount) * 150}px`,
                  background: '#dc3545',
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 0.3s ease'
                }}></div>
              </div>
              
              <div style={{ 
                marginTop: '10px', 
                fontSize: '12px', 
                textAlign: 'center',
                color: '#666'
              }}>
                {month.month}
              </div>
            </div>
          ))}
        </div>
        
        {/* Legend */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '20px',
          marginTop: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <div style={{ width: '12px', height: '12px', background: '#28a745', borderRadius: '2px' }}></div>
            <span style={{ fontSize: '12px' }}>Income</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <div style={{ width: '12px', height: '12px', background: '#dc3545', borderRadius: '2px' }}></div>
            <span style={{ fontSize: '12px' }}>Expenses</span>
          </div>
        </div>
      </div>

      {/* Trend Line */}
      <div style={{
        background: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px'
      }}>
        <h4 style={{ marginBottom: '15px' }}>Cash Flow Trend</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '10px' }}>
          {monthlyData.map((month, index) => (
            <div key={index} style={{
              textAlign: 'center',
              padding: '10px',
              background: month.balance >= 0 ? '#d4edda' : '#f8d7da',
              borderRadius: '6px'
            }}>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
                {month.month}
              </div>
              <div style={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: month.balance >= 0 ? '#155724' : '#721c24'
              }}>
                {month.balance >= 0 ? '+' : ''}₹{month.balance.toFixed(0)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Key Metrics */}
      <div style={{ 
        marginTop: '30px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px'
      }}>
        <div style={{
          padding: '15px',
          background: '#e7f3ff',
          borderRadius: '8px'
        }}>
          <h4 style={{ marginBottom: '10px', color: '#0066cc' }}>Average Monthly Income</h4>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#0066cc' }}>
            ₹{(monthlyData.reduce((sum, m) => sum + m.collected, 0) / monthlyData.length).toFixed(2)}
          </div>
        </div>
        
        <div style={{
          padding: '15px',
          background: '#fff3e0',
          borderRadius: '8px'
        }}>
          <h4 style={{ marginBottom: '10px', color: '#ff6f00' }}>Average Monthly Expenses</h4>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#ff6f00' }}>
            ₹{(monthlyData.reduce((sum, m) => sum + m.spent, 0) / monthlyData.length).toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinancialCharts;